import { render, staticRenderFns } from "./Mob-Button.vue?vue&type=template&id=6df207af"
import script from "./Mob-Button.vue?vue&type=script&lang=js"
export * from "./Mob-Button.vue?vue&type=script&lang=js"
import style0 from "./Mob-Button.vue?vue&type=style&index=0&id=6df207af&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports